<template>
<div style="text-align:right">
   <iframe 
  style="width:100%;height:500px" 
  :src="this.url" 
  title="Impressão da nota de crédito"
  allow="fullscreen">
</iframe>

<v-btn @click="Voltar()">Fechar</v-btn>
</div>
</template>

<script>

import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
export default {
  data: () => ({
    TotalincidenciaIva:0,
    TotalincidenciaIsento:0,
    couterIva:0,
    counterIsento:0,
    totalIliquido:0,
    totalDesconto:0,
    totalImposto:0,
    pkVenda:0,
    totalFactura:0,
    tabelaResumoImposto: [],
    notas: [],
    valid: false,
    isLoading: false,
    url: 'http://localhost:8085/',
    html: '',
    documento: {
      'pkDoc': 0,
      'descricao': ''
    },
    documentos: [
      {
        'pkDoc': 3,
        'descricao': 'Factura Recibo'
      }

    ],
    factura:
{
  'nome_empresa': 'Ilha da Verdade',
  'cliente': 'Alexandrina Francisco de Almeida',
  'matricula': '3333332-26',
  'localidade': 'Luanda, Cazenga',
  'zona': '',
  'provincia': '',
  'telefone': '999207671',
  'email': 'ColegioBendizer@gmail.co.ao',
  'detalhes': 'Matric. Conservatória do Registo Comercial de Luanda',
  'contribuente': '5480006576',
  'contribuente_cliente': '999999999',
  'NIF': '5417492760',
  'notadebito': 'NC 2/20571',
  'ref': 'WDBWLG0040HB',
  'factura': 'FT 01P2021/1',
  'items': [
    {
      'qtd': '1',
      'produto': 'Caderno A4',
      'unit': '250,00',
      'iva': '14%',
      'tx': '0',
      'ref': 'WDBWLG0040HB',
      'cod': 'Demov.5'
    },
    {
      'qtd': '1',
      'produto': 'Fevereiro',
      'unit': '250,00',
      'iva': '14%',
      'tx': '0',
      'ref': 'WDBWLG0040HB',
      'cod': 'Demov.5'
    },
    {
      'qtd': '1',
      'produto': 'Março',
      'unit': '250,00',
      'iva': '14%',
      'tx': '0',
      'ref': 'WDBWLG0040HB',
      'cod': 'Demov.5'
    }
  ],
  'total': 750,
  'number_item': 1,
  'It2D': 'Documento Processado por programa validado',
  'utilizador': 'Pedro'
},
    mes_ano: '',
    data_actual: '',
    dataHora: '',
    hora: '',
    formatter: 0
  }),
  created () {
    this.data_hora()
    this.notadebito_(ls.get('pkVenda')).then((res)=>{
      this.notas = res
      this.CalculaTotais(res)
      this.calculaIncidencia(res)
      console.log(this.notas);
      this.comporHtml(res)
    }).catch((error)=>{

    })
  },

  methods: {
    Voltar(){
      this.$router.push('welcome')
    },
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    data_hora () {
      let data = new Date()
      this.mes_ano = (data.getFullYear()) + (data.getMonth() + 1)
      this.data_actual =(data.getFullYear()) +'-'+ (data.getMonth() + 1) + '-' + data.getDate() 
      this.hora = (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
      this.dataHora = data.getDate() + '-' + (data.getMonth() + 1) + '-' + (data.getFullYear()) + 'T' + (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
    },
    async notadebito_ (pkVenda) {
      console.log(pkVenda);
      try {
        return await axios.post('notaCredito', {pkVenda:pkVenda}).then((res)=>res.data)
        // return await axios({
        //   method: 'post',
        //   url: 'http://localhost:3003/api/notaCredito',
        //   data: {pkVenda:pkVenda}
        // }).then(res => res.data)
        
      } catch (error) {}
    },
    frame () {
      this.isLoading = false
      let frame = `<html> +
      <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style>
      <body>
      <iframe target="_blank" type="application/pdf" src="` + this.url + `"></iframe>
      </body></html>`
    },
    // let html_ = { 'html': this.html, 'usuario': ls.get('nomeUsuario'), 'pkDoc': this.documento.pkDoc }

    async  facturagerarpdf (options) {
      this.isLoading = true
      try {
        await axios({
          method: 'post',
          url: this.url + 'writefile',
          data: {
            html: this.html,
            file_name: ls.get('nomeUsuario'),
            option: options
          }
        }).then(function (response) {
          console.log('sucesso ')
        })
        // Imprimir PDF
        this.url += 'readfile/' + ls.get('nomeUsuario') + '.pdf'
        this.isLoading = false
        this.frame()
      } catch (error) {
        this.isLoading = false
      }
    },

    CalculaTotais (items){
      items.forEach(element => {
          this.totalIliquido += parseInt(element.precoUnitario)
          this.totalDesconto += parseInt(element.descontoLinha === null?0:element.descontoLinha)
      });
    },

    calculaIncidencia (items){
      items.forEach(element => {
          if(element.iva === 14)
          {
            this.couterIva++
            this.TotalincidenciaIva += parseInt(element.precoUnitario)
          }else if(element.iva === 0){
            this.counterIsento++
            this.TotalincidenciaIsento += parseInt(element.precoUnitario)
          }

      });

      // Calcula total de imposto
      this.totalImposto += utilitarios.ObterValorDaPercentagem(this.TotalincidenciaIva,14)+parseInt(0)
      this.tabelaResumoImposto.push({qtdIsento:this.counterIsento, totalIsento:this.TotalincidenciaIsento,qtdIva:this.couterIva,totalIva:this.TotalincidenciaIva})
    },
    formatMoney (value) {
      this.formatter = new Intl.NumberFormat('AOA', {
        style: 'currency',
        currency: 'AKZ'
      })
      var a = this.formatter.format(value)
      return a
    },

    comporHtml (notasCredito) {
      let index = 0
      let items = ''
      let resumoImpostoItems = ''
      let options = { 'format': 'A4',
        'border': { 'top': '20cm', // default is 0, units: mm, cm, in, px
          'right': '25cm',
          'bottom': '5cm',
          'left': '25cm'
        },
        'header': {
          'height': '5mm' },
        'footer': {
          'height': '5mm'
        } }
        let couter = 1
      for (index = 0; index < notasCredito.length; index++) {
        items += ` 
          <tr>
      <td><div style="text-align:left;">ND` + notasCredito[index].fkProduto +`C`+(couter++)+`</div></td>
      <td colspan="2"><div style="text-align:left;">` + notasCredito[index].produto + `</div></td>
      <td>` + utilitarios.IntegerToMoneyValueFatura(notasCredito[index].precoUnitario) + ` Kz </td>
      <td> Uni</td>
      <td> ` + notasCredito[index].qtd_venda + `</td>
      <td>` + utilitarios.IntegerToMoneyValueFatura(notasCredito[index].iva) + `</td>
      <td>` + utilitarios.IntegerToMoneyValueFatura((notasCredito[index].subTotal*notasCredito[index].qtd_venda)) + ` Kz</td>
      </tr>
          `
      }


       this.tabelaResumoImposto.forEach(element => {
        
        if(element.qtdIsento >= 1)
         {
            resumoImpostoItems += `
            <tr>
              <td>Isento</td>
              <td>0</td>
              <td>`+utilitarios.IntegerToMoneyValueFatura(element.totalIsento)+`</td>
              <td>0</td>
            </tr>
            `
         }if( element.qtdIva >= 1){
           resumoImpostoItems += `
            <tr>
              <td>IVA</td>
              <td>14</td>
              <td>`+utilitarios.IntegerToMoneyValueFatura(element.totalIva)+`</td>
              <td>`+utilitarios.IntegerToMoneyValueFatura(utilitarios.ObterValorDaPercentagem(element.totalIva,14))+`</td>
            </tr>`
         }
      });
      //===============



      this.html = ` 
    <style>
  .footer {
    position:absolute;
    bottom:0;
    width:100%;
  }
  #content {
    display: table;
  }

  #pageFooter {
    display: table-footer-group;
     position:absolute;
    bottom:0;
    width:100%;
  }

  #pageFooter:after {
    counter-increment: page;
    content: counter(page);
  }
  .linha {
    border-bottom: 1px solid black;
    border-color: #808080;
    padding-top:2px
  }
   th, td {
      font-size:8px;
      
  }
  .quebra{
    background-color: #ff0000;
    height: 150px;
    width: 250px;
    border: 5px solid #000000;
    float: left;
  }

  </style>
  
    <div style="text-align:left;margin:10px;margin-top:0px" class="invoice-box">
    <table style="border:0px solid black;margin-left:0px;margin-right:auto;">
    <tr>
        <td>
             <div>
     </div>
        </td>
         <td> 
        <strong style="font-size:20">` + this.factura.nome_empresa + `</strong>
  <br><div style="font-size:10;text-align:center">` + this.factura.localidade + `</div>
  <div style="font-size:10;text-align:center">` + this.factura.provincia + `</div>
  <div style="font-size:10;text-align:center">` + this.factura.contribuente + `</div>
        </td>
         
    </tr>
    </table>
    <table style="border:0px solid black;border-collapse: collapse;width:100%">
    <tr>
    <td></td>
    <td style="text-align:center">
    Exmo.(s) Sr.(s)<br>
    <strong>Consumidor Final</strong>
    </td>
    </tr>
       </table>

  <br>
      <table style="border:0px solid black;border-collapse: collapse;width:100%">
      <tr>
      <td colspan="7" style="text-align:left;">
       <div style="font-size: 12px;">Nota de Crédito n.º  NC 2024/176
        </div>
      </td>
      <td style="text-align:right;font-size: 12px;">
      Original
      </td>
      </tr>
      <tr>
      <td colspan="8"><div class="linha"></div> </td>
      </tr>
        <tr>
      <td>
     <div style="font-size: 10px;text-align:left"> 
     <span>Data emissão:` + this.data_actual + `  
     </span>   
     </td>
     <td colspan="3">
     <div style="font-size: 10px;text-align:left"> 
     <span>Contribuente:` + this.factura.contribuente_cliente + `  
     </span>   
     </td>
      </tr>
      <td colspan="8"><div class="linha"></div> </td>
      <tr>
      <td colspan="8">
      <div style="padding-top:30px;font-size:8px">
      <strong>Anulação</strong><br>
      </div> 
      </td>
      </tr>
       <tr>
      <td colspan="8"><div class="linha"></div> </td>
      </tr>
      <td colspan="8">
        <div>Motivo:<strong> Erro na facturação.</strong></div> 
        <div>Documento de origem <strong>` + this.notas[0].numeroDocumento + `</strong></div> 
      </td>
      </tr>
      <tr><td colspan="8"><div style="padding-top:20px" class="linha">Elememntos do documento</div> </td></tr>
      </table>
      <table style="border:0px solid black;border-collapse: collapse;width:100%">
      <tr>
      <th><div style="text-align:left;">Código</div></th>
      <th colspan="2"><div style="text-align:left;">Descrição</div></th>
      <th><div style="text-align:left;">P. Uni.</div> </th>
      <th><div style="text-align:left;"> Uni.</div></th>
      <th><div style="text-align:left;"> Qtd</div></th>
      <th><div style="text-align:left;">Taxa</div></th>
      <th><div style="text-align:left;">Total</div></th>
      </tr>
      ` + items + `
<tr><td colspan="8"><div class="linha"></div> </td></tr>
<tr> 
 <td colspan="7"><strong> Total Ilíquido</strong></td>  
 <td colspan="2" style="font-size:8px;"><strong>`+utilitarios.IntegerToMoneyValueFatura(this.totalIliquido)+`</strong></td>    
</tr>
<tr> 
 <td colspan="7"><strong> Total de desconto</strong></td> 
 <td colspan="2" style="font-size:8px;"><strong>`+utilitarios.IntegerToMoneyValueFatura(this.totalDesconto)+`</strong></td>       
</tr>
<tr> 
 <td colspan="7"><strong> Total de imposto</strong></td>   
 <td colspan="2" style="font-size:8px;"><strong>`+utilitarios.IntegerToMoneyValueFatura(this.totalImposto)+`</strong></td>     
</tr>
<tr> 
 <td colspan="7"><strong> Total da factura</strong></td>    
 <td colspan="2" style="font-size:8px;"><strong>`+utilitarios.IntegerToMoneyValueFatura(this.totalIliquido+this.totalImposto)+`</strong></td>    
</tr>
<tr>
<td colspan="8" class="linha">Meio de Pagamento</td></tr>
 <tr>
   <td colspan="7">Dinheiro</td>
   <td colspan="2" style="font-size:8px;"><strong>`+utilitarios.IntegerToMoneyValueFatura(notasCredito[0].valorPago)+`</strong></td> 
  </tr>   
<tr>
   <td colspan="7">Troco</td>
   <td colspan="2" style="font-size:8px;"><strong>`+utilitarios.IntegerToMoneyValueFatura(notasCredito[0].troco)+`</strong></td> 
  </tr>  
<tr><td colspan="8"><div style="padding-bottom:50px"></div> </td></tr>
    <tr>
     <td>
        
     </td>
   </tr>
  <tr><td colspan="8" class="linha"></td></tr>
  <tr><td colspan="8"><div style="padding-bottom:50px"></div> </td></tr>
  <tr><td colspan="4"></td>
  <td colspan="4" class="linha"></td></tr>
  <tr><td colspan="4"></td>
  <td colspan="4" style="text-align:center;">Assinatura do cliente</td></tr>
 </table>
<div class="footer" style=" font-size: 10px;text-align:center;">tcTD-Processado por programa validado nº 0000/AGT/2022 <br>
<span style="font-size:8px;"></span><br>
  <span style="text-align:right;font-size: 7px; ">SoftlineAgola info:www.softlineangola.com</span>
</div>
      </table>
              `
      setTimeout(() => {
        this.facturagerarpdf(options)
      }, 0)
    }
  }

}

</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}
.progressCircularIsMatriculaURL {
  margin: 1rem;

  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;

}
</style>
